module.exports = __webpack_public_path__ + "media/images/EUflag-3b157f7ac225d81c86f6cec36164b205.svg";